<template>
  <div class="landing-search">
    <loader v-if="loader" />
    <button
      class="landing-page__button landing-search__button"
      :class="{'landing-page__button_disabled':
        (!activeCountry || !activeServiceTypes)
        || (activeStep === 3 && activeManagementForms === -1)
      }"
      :disabled="
        (!activeCountry || !activeServiceTypes)
          || (activeStep === 3 && activeManagementForms === -1)"
      @click="getInfo()"
    >
      {{ $t('global.getInfo') }}
    </button>
    <stepFirst
      :items="createdCountriesList"
      :activeCountry.sync="activeCountry"
      :setActiveCountry="'setActiveCountry'"
      @selectedCountry="selectedCountry"
      @selectCountry="selectCountry"
      @conditionStep="conditionStep"
    />
    <stepSecond
      :items="allTypeServices"
      :isDefault.sync="isDefault"
      :activeServiceTypes.sync="activeServiceTypes"
      :disableSecondStep.sync="disableSecondStep"
      @setActiveServicesType="setActiveServicesType"
      @getServicesList="getServicesList"
      @selectedServicesType="selectedServicesType"
      @setActiveStep="setActiveStep"
    />
    <template v-if="activeStep === 3">
      <stepThird
        :items="serviceManagementForms"
        :activeManagementForms="activeManagementForms"
        @getServicesList="getServicesList"
        @setActiveManagementForms="setActiveManagementForms"
      />
    </template>
  </div>
</template>

<script>
import servicesApi from '@/api/services/servicesApi';
import countriesApi from '@/api/countries/countriesApi';
import stepFirst from '@/components/landing/steps/stepFirst';
import stepSecond from '@/components/landing/steps/stepSecond';
import stepThird from '@/components/landing/steps/stepThird';
import { find } from 'lodash';
import loader from '@/components/loader';

export default {
  name: 'Steps',
  components: {
    stepFirst,
    stepSecond,
    stepThird,
    loader,
  },
  data: () => ({
    disableSecondStep: true,
    activeStep: 1,
    servicesListDef: [],
    activeCountry: '',
    activeServiceTypes: '',
    activeService: '',
    activeManagementForms: -1,
    allTypeServicesDef: [],
    serviceManagementFormsDef: [],
    allCountriesListDef: [],
    isDefault: false,
    loader: false,
  }),
  computed: {
    serviceManagementForms: {
      get() {
        return this.serviceManagementFormsDef;
      },
      set(data) {
        this.serviceManagementFormsDef = data;
      },
    },
    allTypeServices: {
      get() {
        return this.allTypeServicesDef;
      },
      set(data) {
        this.allTypeServicesDef = data;
      },
    },
    servicesList: {
      get() {
        return this.servicesListDef;
      },
      set(data) {
        this.servicesListDef = data;
      },
    },
    allCountriesList: {
      get() {
        return this.allCountriesListDef;
      },
      set(data) {
        this.allCountriesListDef = data;
      },
    },
    createdCountriesList() {
      return this.allCountriesList.filter((item) => item.isVisible);
    },
    language() {
      return this.$i18n.locale;
    },
  },
  beforeMount() {
    const queryParams = 'withServices=true';
    countriesApi.getCreatedCountriesWithServices(queryParams).then((resp) => {
      const arr = [];
      resp.data.forEach((item) => {
        arr.push(
          {
            ...item,
            image: `country/${item.code}.svg`,
          },
        );
      });
      this.allCountriesList = arr;
      return arr;
    }).catch((err) => {
      console.error(err);
    });
  },
  methods: {
    conditionStep(data) {
      this.disableSecondStep = data;
    },
    getInfo() {
      if (this.activeServiceTypes) {
        this.getServicesList();
      }
    },
    selectedCountry() {
      const page = 1;
      const perPage = 20;
      const filterQuery = {
        country: this.activeCountry,
      };
      this.loader = true;
      servicesApi.getServicesTypeListByCountry({ page, perPage, filter: JSON.stringify(filterQuery) })
        .then((resp) => {
          const { totalDocs, resource } = resp.data;
          this.noData = {
            ...this.noData,
            status: totalDocs === 0,
          };
          this.allTypeServices = resource;
          this.loader = false;
          this.activeStep = 2;
        }).catch((err) => {
          this.loader = false;
          console.error(err);
        });
    },
    setActiveStep(data) {
      this.activeStep = data;
    },
    selectedServicesType() {
      const page = 1;
      const perPage = 20;
      const filterQuery = {
        country: this.activeCountry,
        serviceTypes: this.activeServiceTypes,
      };
      this.loader = true;
      servicesApi.getServicesManagerForm({ page, perPage, filter: JSON.stringify(filterQuery) })
        .then((resp) => {
          const { totalDocs, resource } = resp.data;
          this.noData = {
            ...this.noData,
            status: totalDocs === 0,
          };
          this.serviceManagementForms = resource;
          this.loader = false;
        }).catch((err) => {
          this.loader = false;
          console.error(err);
        });
    },
    getServicesList() {
      const page = 1;
      const perPage = 20;
      const activeManagementForm = this.serviceManagementForms.length && this.activeManagementForms !== -1
        ? this.serviceManagementForms[this.activeManagementForms][this.language]
        : undefined;
      const filterQuery = {
        'country._id': this.activeCountry,
        serviceTypes: this.activeServiceTypes,
        [`managementForm.${this.language}`]: activeManagementForm,
      };
      servicesApi.getServicesList({ page, perPage, filter: JSON.stringify(filterQuery) })
        .then((resp) => {
          const { resource } = resp.data;
          const compare = resource.map((item) => item._id);
          if (compare.length === 1) {
            this.$router.push({
              name: `service-${this.language}`,
              query: {
                id: compare,
              },
            });
          } else {
            this.$router.push({
              name: `compare-${this.language}`,
              query: {
                compare,
              },
            });
          }
        }).catch((err) => {
          console.error(err);
        });
    },
    selectCountry(id) {
      this.activeCountry = id;
      this.activeServiceTypes = '';
      this.isDefault = false;
    },
    setActiveServicesType(id) {
      this.activeServiceTypes = id;
      const currentType = find(this.allTypeServices, (item) => item._id === id);
      this.isDefault = currentType.isDefault;
      this.activeManagementForms = -1;
    },
    setActiveManagementForms(index) {
      this.activeManagementForms = index;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

  .landing-search {
    margin-top: 10px;
    width: 100%;

    &__button {
      position: absolute;
      left: 33px;
      bottom: -62px;
      max-width: 289px;
      width: 100%;
      height: 61px;
      background-image: linear-gradient(80deg, $color-science-blue 0%, $color-blue-ribbon-dark 100%);
      letter-spacing: .3px;
    }

    &-content {
      margin: 18px auto 0;
      min-height: 130px;

      &__scroll {
        max-height: 305px;
        display: flex;
        align-items: flex-end;
        width: 100%;
        padding-bottom: 15px;
      }

      &_slider {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &-row {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 25px;

        &__list {
          display: flex;
          flex-direction: row;
          margin-top: 16px;
          flex-wrap: wrap;

          &_service {
            justify-content: center;
            margin-top: 0;
            text-align: left;
          }

          &_field {
            max-width: 950px;
            justify-content: flex-start;
          }
        }

        &__item {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 147px;
          max-height: 147px;

          &_active {
            border-color: $color-dodger-blue;
          }

          &-title {
            margin-top: 9px;
            font: $font-size-md $font-global-bold;
            color: $color-black;
            user-select: none;
          }

          &-compare {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background: $color-gallery;
            position: absolute;
            top: 15px;
            right: 18px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: background-color .15s ease-in, color .15s ease-in;

            &_active {
              background: $color-dodger-blue;
            }

            &:hover {
              background: $color-dodger-blue;
            }

            & i {
              color: $color-white;
            }
          }

          &-text {
            font: $font-size-md $font-global;
            color: $color-black;
            display: flex;
            justify-content: space-between;
            margin-top: 4px;
            user-select: none;
          }

          &-country {
            font: $font-size-base $font-global-bold;
            color: $color-mine-shaft;
            user-select: none;
          }

          &_field {
            border: 1px solid $color-gallery;
            border-radius: $borderRadius;
            padding: 12px;
            height: 40px;
            margin: 0 5px 12px;
            min-width: 290px;
            display: flex;
            justify-content: flex-start;
          }

          &_active {
            border: 1px solid $color-dodger-blue;
          }
        }
      }

      &__slider {
        cursor: pointer;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 114px;
        height: 114px;

        &_active {
          border: 1px solid $color-dodger-blue;
          border-radius: $borderRadius;
        }

        &-text {
          font: $font-size-sm $font-landing-global;
          color: $color-silver-chalice;
          text-align: center;
          margin-top: 6px;

          &_active {
            color: $color-dodger-blue;
            font: $font-size-base $font-landing-global;
          }
        }
      }

      &__item {
        border: 1px solid $color-gallery;
        border-radius: $borderRadius;
        min-height: 60px;
        padding: 19px 5px;
        color: $color-silver-chalice;
        width: 210px;
        align-items: center;
        justify-content: center;
        display: flex;
        margin: 0 6px 12px;
        text-align: center;
        cursor: pointer;
        transition: opacity .15s ease-in;
        user-select: none;

        &:hover {
          opacity: .8;
        }

        &_active {
          border-color: $color-dodger-blue;
          color: $color-dodger-blue;
        }
      }

      &__list {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;
        justify-content: center;
      }
    }
  }

@include tablet-old {
  .landing-search {
    &__button {
      left: 0;
    }
  }
}

@include tablet-portrait {
  .landing-search {
    &__button {
      left: 50%;
      transform: translateX(-50%);
      bottom: -69px;
    }
  }
}

@include mobile {
  .landing-search {
    padding: 20px 0;
    min-height: auto;

    &__button {
      bottom: -49px;
    }
  }
}

</style>
